import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import Cookies from 'js-cookie';

// Initialize GA with consent mode
window.gtag('consent', 'default', {
  'analytics_storage': 'denied'
});

// Check for existing consent
if (Cookies.get('analytics') === 'true') {
  window.gtag('consent', 'update', {
    'analytics_storage': 'granted'
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
